import { useTrackOnClick } from '@f/hooks/tracking/useTrackOnClick'

void (() => {
  const houseMosaicItemsGroups = document.querySelectorAll(
    '.js-house-mosaic-items'
  )
  for (const houseMosaicItemsGroup of houseMosaicItemsGroups) {
    const trackHouseMosaic = () => {
      try {
        const houses = JSON.parse(houseMosaicItemsGroup.dataset.houseIds)
        _wt({
          category: 'item-collection',
          action: 'display',
          label: 'house-mosaic',
          values: houses.map(house => ({
            type: 'house_nid',
            value: house.nid
          }))
        })
      } catch (e) {}
    }

    if (!!window.IntersectionObserver) {
      /* Modern browsers track when the element is on display */
      const observer = new IntersectionObserver((entries, observer) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            trackHouseMosaic()
            observer.unobserve(entry.target)
          }
        }
      })

      observer.observe(houseMosaicItemsGroup)
    } else {
      /* IE */
      trackHouseMosaic()
    }
  }

  const houseMosaicItems = document.querySelectorAll('.js-house-mosaic-item')

  for (const houseMosaicItem of houseMosaicItems) {
    houseMosaicItem.addEventListener('click', event => {
      const { currentTarget: item } = event

      if (!/is-hovering/.test(item.className)) {
        event.preventDefault()
        item.classList.add('is-hovering')
      } else {
        const wtData = {
          category: 'item',
          action: 'click',
          values: [
            {
              type: 'house_nid',
              value: houseMosaicItem.dataset.houseNid
            }
          ],
          label: 'card-house-mosaic',
          location: 'house-mosaic'
        }

        useTrackOnClick({ event, wtData })
      }
    })

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      houseMosaicItem.addEventListener('mouseenter', event => {
        const { currentTarget: item } = event
        item.classList.add('is-hovering')
      })

      houseMosaicItem.addEventListener('mouseleave', event => {
        const { currentTarget: item } = event
        item.classList.remove('is-hovering')
      })
    }
  }
})()
